var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.check())?_c('v-container',{staticClass:"pa-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":12}},[_c('router-view')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }